import React from 'react';
import PropTypes from 'prop-types';

export default function ArrowUpRight(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke={props.color || 'currentColor'} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-arrow-up-right" {...props}>
      <line x1={7} y1={17} x2={17} y2={7} />
      <polyline points="7 7 17 7 17 17" ></polyline>
    </svg>
  );
}

ArrowUpRight.propTypes = {
  color: PropTypes.string
};